import { Position } from "@/services/backend/vbs/treatments/types/position";
import { useVbsTreatmentUpdatePositionCompletionMutation } from "@/services/backend/vbs/treatments/api/treatment-api";
import { useToast } from "@/shared/hooks/use-toast";
import { useEffect } from "react";
import { parseRTKQueryError } from "@/shared/components/errors/parse-r-t-k-query-error";
import { CheckedState } from "@radix-ui/react-checkbox";
import { Checkbox } from "@/shared/components/ui/checkbox";
import { cn } from "@/shared/lib/utils";

export function CompletedCell({
  treatmentId,
  position,
  disabled,
  className,
}: {
  treatmentId: string;
  position: Position;
  disabled?: boolean;
  className?: string;
}) {
  const [update, { isLoading, error, reset }] =
    useVbsTreatmentUpdatePositionCompletionMutation();
  const { toast } = useToast();

  useEffect(() => {
    if (error) {
      reset();
      toast({
        ...parseRTKQueryError(error),
        variant: "destructive",
      });
    }
  }, [error, reset, toast]);

  const onCheckedChange = (status: CheckedState) => {
    if (isLoading) {
      return;
    }
    if (status === "indeterminate") {
      return;
    }

    update({
      id: treatmentId,
      positionId: position.id,
      completed: status,
      forceCompletion: false,
    });
  };

  return (
    <Checkbox
      className={cn("h-7 w-7", className)}
      checked={position.completed}
      onCheckedChange={onCheckedChange}
      disabled={disabled || position.immutable || isLoading}
    />
  );
}
